
import AnScene from './AnScene';

aScene = new AnScene();
aScene.init();



// WEBPACK FOOTER //
// ./src/js/scene/scene.js